import React from "react";

import "./style.css";

const Nav = () => {
  return (
    <nav>
      <ul>
        <li>
          <a href="#Sobre">Sobre</a>
          <a href="#Local">Local</a>
        </li>
      </ul>
    </nav>
  );
};

export default Nav;
